jQuery(document).ready(function($) {

  $("div.slick-slide>a>img").attr("alt","brand slide products")
  $("div.mobile-nav__toggle  button.collapsible-trigger").append("<span style='display:none'>.</span>");
   $("div.mobile-nav__child-item  button.collapsible-trigger").append("<span style='display:none'>.</span>");
  $("div.site-nav__dropdown a.megamenu__colection-image").attr("aria-label","menu items");
  $('a[href="/products/birthday-cake-hot-cocoa"]').attr('aria-label', 'Birthday Cake Hot Cocoa Product');
$('a[href="/products/chai-tea-latte-mix"]').attr('aria-label', 'Chai Tea Latte Mix Product');
$('input[name="quantity"]').attr('aria-label', 'Quantity');
$('img.zoomImg:not([alt])').attr('alt', 'Zoom Product Image');
  $('a[href="/blogs/coconut-cloud/no-bake-coconut-snowball-cookies-vegan-gluten-free"]').attr("aria-label", "no bake coconut snowball");
$('a[href="/blogs/coconut-cloud/pumpkin-pie-overnight-oats-dairy-free-gf"]').attr("aria-label", "pumpkin pie overnight oats dairy-free gluten-free");
$('a[href="/blogs/coconut-cloud/easy-lemon-mousse-vegan-gf"]').attr("aria-label", "easy lemon mousse vegan gluten-free");
  $('a.site-nav__link[href="/cart"]').removeAttr('aria-controls');
$('img[src="https://cdn.shopify.com/s/files/1/2257/2079/files/logo-add-off.png"]').attr("alt","add a scoop brand logo");
$('img[src="https://cdn.shopify.com/s/files/1/2257/2079/files/logo-coco-off.png"]').attr("alt","coconut cloud brand logo");
$('img[src="https://cdn.shopify.com/s/files/1/2257/2079/files/logo-alov-off.png"]').attr("alt","alovitox brand logo");
$('img[src="https://cdn.shopify.com/s/files/1/2257/2079/files/logo-add-on.png"]').attr("alt","add a scoop brand logo in white colour");
$('img[src="https://cdn.shopify.com/s/files/1/2257/2079/files/logo-coco-on.png"]').attr("alt","coconut cloud brand logo in white colour");
$('img[src="https://cdn.shopify.com/s/files/1/2257/2079/files/logo-alov-on.png"]').attr("alt","alovitox brand logo in white colour");
// Remove aria-hidden attribute from div.brands-slide--1585678788431
$('div.brands-slide--1585678788431').removeAttr('aria-hidden');
  $("#AnnouncementSlider div.slick-track").attr("aria-label","annoucement bar");
  $("div#Brands-1585676385922 > div.slick-list > div.slick-track > div.center").attr("aria-label","hot cocoa birthday cake");
  $("div.brands-slider  div.slick-track").attr("aria-label","Find us at");
$("button.shopify-payment-button__button").append("<span style='display:none'>.</span>");
$("button.shopify-payment-button__more-options").append("<span style='display:none'>.</span>");
$('a[href="/products/pumpkin-spice-dairy-free-coffee-creamer"]>div>img').attr("alt","Cocunut milk creamer laid on table")
  $('div[aria-describedby="slick-slide21"]').removeAttr('aria-hidden');
$("img[src='//coconutcloud.net/cdn/shop/t/10/assets/sca.location-find-location.png?v=51886213657725413881588470660']").attr("alt","find location icon");
  // Add alt tags based on srcset attributes
$('img[srcset*="//coconutcloud.net/cdn/shop/files/non-gmo"]').attr('alt', 'Non-GMO');
$('img[srcset*="//coconutcloud.net/cdn/shop/files/gluten-free"]').attr('alt', 'Gluten-Free');
$('img[srcset*="//coconutcloud.net/cdn/shop/files/soy-free"]').attr('alt', 'Soy-Free');
$('img[srcset*="//coconutcloud.net/cdn/shop/files/dairy-free"]').attr('alt', 'Dairy-Free');
$('img[srcset*="//coconutcloud.net/cdn/shop/files/vegan"]').attr('alt', 'Vegan');
$('img[srcset*="//coconutcloud.net/cdn/shop/files/made-in-usa"]').attr('alt', 'Made in USA');
 
$(".jdgm-rev__title").attr("tabindex",0);
  $(".jdgm-rev__body>p").attr("tabindex",0);
  $('.jdgm-rev__author').each(function() {
    var authorName = $(this).text();
    $(this).attr('aria-label', 'Review by ' + authorName);
      $(this).attr('tabindex', 0);
  });
let Intervaltime_slick;
let counter_slick = 0; // counter to track the number of times the function is called


try {
    Intervaltime_slick = setInterval(GenerateAriaLabelForSlick, 500);
}
catch (err) {
  
}

  $('button[name="commit"]').attr("aria-label","commit button");

function GenerateAriaLabelForSlick() {
    // Increment the counter each time the function is called
    counter_slick++;


  // Check if the target element exists
    if ( $("div.slick-slide").length) {
      console.log("slick slide found");
  $("div.slick-slide").removeAttr("aria-describedby");
      
       // clearInterval(Intervaltime_slick);
       
    }
    // Clear the interval if the function has been called 10 times
    if (counter_slick >= 10) {
        clearInterval(Intervaltime_slick);
       
    }
}
  let Intervaltime_google;
let counter_google = 0; // counter to track the number of times the function is called


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
    // Increment the counter each time the function is called
    counter_google++;


    // Check if the target element exists
    if ( $('#goog-gt-votingInputSrcLang').length) {
      $("label.adb-switch").append('<span style="display:none">.</span>');
        $('textarea[name="h-captcha-response"]').attr("aria-label", "Captcha verification response");
$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}


    let Intervaltime_reviews;
let counter_reviews = 0; // counter to track the number of times the function is called


try {
  $('.jdgm-paginate a').on('click', function() {
    // Your functionality here
    GenerateAriaLabelReviews()
  Intervaltime_reviews = setInterval(GenerateAriaLabelReviews, 500);
  });
   
}
catch (err) {
  
}


function GenerateAriaLabelReviews() {
    // Increment the counter each time the function is called
    counter_reviews++;
debugger;
  if( $(".jdgm-rev__author").length){
    
$(".jdgm-rev__title").attr("tabindex",0);
  $(".jdgm-rev__body>p").attr("tabindex",0);
  $('.jdgm-rev__author').each(function() {
    var authorName = $(this).text();
    $(this).attr('aria-label', 'Review by ' + authorName);
      $(this).attr('tabindex', 0);
     
  });
     clearInterval(Intervaltime_reviews);
 
  }

    // Check if the target element exists
  }
  
 $("#shopify-section-article-template img").each(function() {
   console.log("imgae found");
      if (!$(this).attr("alt") || $.trim($(this).attr("alt")) === "") {
        $(this).attr("alt", "blog images");
      }
    });
  console.log( $("div.slick-slide>a>img")[0]);
  $("h2:empty").append("<span style='display:none'>.</span>")


$('img[src="//cdn.shopify.com/s/files/1/2258/9733/products/HOT_COCOA_ORIGINAL_large.png"]').attr("alt","hot cocoa original front side");
$('img[src="//cdn.shopify.com/s/files/1/2258/9733/products/HOTCOCOAORIGINALBACK_b59d446e-9f79-4619-a849-f5871f02d90b_large.png"]').attr("alt","hot cocoa original back side with ingredients");
$('img[src="//cdn.shopify.com/s/files/1/2258/9733/products/cocoaheartpowder_large.jpg"]').attr("alt","hot cocoa coffee packet along with cup of coffee");
$('img[src="//cdn.shopify.com/s/files/1/2258/9733/products/cocoawood_large.png"]').attr("alt","hot cocoa coffee packet placed on table");
$('img[src="https://cm.g.doubleclick.net/pixel?google_nid=klickly_inc&google_cm=1&klickly_cid=6374ba99-17a0-4460-bb02-df4eeab0cee6"]').attr("alt","").attr("role","presentation");
$('select.product-single__variants.no-js').attr("aria-label", "Select product variant");


});
/*
$('button.btn.add-to-cart').on('click',function() {
   
    $('#cart-status').text('Item added to cart');
  });
*/
window.onload = function() {
    $("div.slick-slide>a>img").attr("alt","brand slide products")
    $("div.slick-slide").removeAttr("aria-describedby");
    setTimeout(function() {
    $("div.slick-slide").removeAttr("aria-describedby");
      $('img.zoomImg:not([alt])').attr('alt', 'Zoom Product Image');
      $('input[name="visitor[email]"]').attr("aria-label","enter your email for getting best offers");
       $('textarea[name="h-captcha-response"]').attr("aria-label", "Captcha verification response");
  }, 1000);
 
};